import { render } from "./mercadopagoForm.vue?vue&type=template&id=4f186c09&ts=true"
import script from "./mercadopagoForm.vue?vue&type=script&lang=ts"
export * from "./mercadopagoForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__